export default {"src":"/_next/static/media/NXPI.1b9045b9.svg","height":18,"width":18};